import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from "../../Context/auth"; // Ajuste o caminho se necessário
import Swal from 'sweetalert2';
import './ModalConfiguracoes.css';

// Estilos básicos para o modal
const modalStyle = {
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex',
    justifyContent: 'center', alignItems: 'center', zIndex: 1050
};
const contentStyle = {
    backgroundColor: 'white', padding: '25px', borderRadius: '8px',
    width: '90%', maxWidth: '600px', // Aumentei um pouco a largura para as abas
    boxShadow: '0 5px 15px rgba(0,0,0,.5)'
};

// Componente de Input para a aba Etiquetas (para limpar o código)
const EtiquetaInput = ({ label, name, value, onChange, placeholder, loading }) => (
    <div className="col-md-6 mb-3">
        <label htmlFor={name} className="form-label small text-muted">{label}</label>
        <div className="input-group input-group-sm">
            <input
                type="number"
                className="form-control form-control-sm"
                id={name}
                name={name}
                value={value || ''}
                onChange={onChange}
                placeholder={placeholder}
                disabled={loading}
            />
            <span className="input-group-text">mm</span>
        </div>
    </div>
);


// Componente de Tooltip simples (clique para abrir/fechar)
const InfoTooltip = ({ text, children }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="d-inline-block position-relative ms-2" style={{ verticalAlign: 'middle' }}>
            <i
                className="fas fa-info-circle text-primary"
                style={{ cursor: 'pointer', fontSize: '0.9rem' }}
                onClick={() => setIsOpen(!isOpen)}
                title="Clique para ver mais informações"
            ></i>
            {isOpen && (
                <div
                    className="position-absolute bg-white border rounded shadow p-2"
                    style={{
                        zIndex: 1060,
                        width: '250px',
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        marginTop: '5px',
                        fontSize: '0.85rem',
                        lineHeight: '1.4'
                    }}
                >
                    <div className="d-flex justify-content-between align-items-start mb-1">
                        <small className="fw-bold text-muted">Informação</small>
                        <button type="button" className="btn-close btn-close-white" style={{ fontSize: '0.5rem', filter: 'none' }} aria-label="Close" onClick={() => setIsOpen(false)}></button>
                    </div>
                    <div className="text-dark">
                        {text || children}
                    </div>
                </div>
            )}
        </div>
    );
};

function ModalConfiguracoes({ isVisible, onClose }) {
    const { currentUser, appUserData } = useAuth();

    // Verifica se tem módulo de estoque (ID 2)
    // O usuário citou "Controle de Produção", mas como o PedidoForm (que usa ID 2) funciona,
    // assumimos que o ID 2 (Estoque) está presente ou é o que controla isso.
    const hasModuloEstoque = appUserData?.modulos?.includes(2);

    // --- NOVO: Estado para aba ---
    const [activeTab, setActiveTab] = useState('geral'); // 'geral', 'etiquetas', 'pedidos'

    // --- NOVO: Estado unificado para todas as configurações ---
    const [configuracoes, setConfiguracoes] = useState({
        logomarca_url: null,
        etiqueta_coletiva_largura_mm: '',
        etiqueta_coletiva_altura_mm: '',
        etiqueta_individual_largura_mm: '',
        etiqueta_individual_altura_mm: '',
        etiqueta_romaneio_largura_mm: '',

        etiqueta_romaneio_altura_mm: '',
        movimentar_estoque_pedido: false, // Novo campo
        tipo_pedido_padrao: 'Representacao', // Novo campo
    });

    const [selectedFile, setSelectedFile] = useState(null); // Novo arquivo selecionado
    const [previewUrl, setPreviewUrl] = useState(null); // URL de preview local
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const fileInputRef = useRef(null); // Ref para o input file

    // Hook de API (sem alterações)
    const apiCall = useCallback(async (url, method = 'GET', body = null, isFormData = false) => {
        if (!currentUser) throw new Error("Usuário não autenticado.");
        const token = await currentUser.getIdToken();
        const API_URL = process.env.REACT_APP_API_URL;
        const headers = { 'Authorization': `Bearer ${token}` };
        if (!isFormData && body && method !== 'GET') {
            headers['Content-Type'] = 'application/json';
        }
        const config = { method, headers };
        if (body) {
            config.body = isFormData ? body : JSON.stringify(body);
        }

        const response = await fetch(`${API_URL}${url}`, config);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `Falha na requisição (${response.status})`);
        }
        return response.status !== 204 ? response.json() : null;
    }, [currentUser]);

    // Busca a configuração atual ao abrir o modal
    useEffect(() => {
        if (isVisible && currentUser) {
            setLoading(true);
            setError('');

            apiCall('/api/configuracoes') // Endpoint GET
                .then(data => {
                    // --- ATUALIZADO: Popula o estado unificado ---
                    setConfiguracoes({
                        logomarca_url: data?.logomarca_url || null,
                        etiqueta_coletiva_largura_mm: data?.etiqueta_coletiva_largura_mm || '',
                        etiqueta_coletiva_altura_mm: data?.etiqueta_coletiva_altura_mm || '',
                        etiqueta_individual_largura_mm: data?.etiqueta_individual_largura_mm || '',
                        etiqueta_individual_altura_mm: data?.etiqueta_individual_altura_mm || '',
                        etiqueta_romaneio_largura_mm: data?.etiqueta_romaneio_largura_mm || '',

                        etiqueta_romaneio_altura_mm: data?.etiqueta_romaneio_altura_mm || '',
                        movimentar_estoque_pedido: data?.movimentar_estoque_pedido === true || data?.movimentar_estoque_pedido === 'true',
                        tipo_pedido_padrao: data?.tipo_pedido_padrao || 'Representacao',
                    });
                })
                .catch(err => {
                    setError('Erro ao carregar configurações: ' + err.message);
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            // Limpa ao fechar
            setSelectedFile(null);
            setPreviewUrl(null);
            setError('');
            setActiveTab('geral'); // Reseta a aba
            setConfiguracoes({ // Reseta o estado
                logomarca_url: null,
                etiqueta_coletiva_largura_mm: '',
                etiqueta_coletiva_altura_mm: '',
                etiqueta_individual_largura_mm: '',
                etiqueta_individual_altura_mm: '',
                etiqueta_romaneio_largura_mm: '',

                etiqueta_romaneio_altura_mm: '',
                movimentar_estoque_pedido: false,
                tipo_pedido_padrao: 'Representacao',
            });
            if (fileInputRef.current) fileInputRef.current.value = null;
        }
    }, [isVisible, currentUser, apiCall]);

    // Força tipo Representacao se não tiver modulo de estoque
    useEffect(() => {
        if (!hasModuloEstoque && configuracoes.tipo_pedido_padrao === 'Estoque') {
            setConfiguracoes(prev => ({ ...prev, tipo_pedido_padrao: 'Representacao' }));
        }
    }, [hasModuloEstoque, configuracoes.tipo_pedido_padrao]);

    // Cria/Revoga URL de preview (sem alterações)
    useEffect(() => {
        if (!selectedFile) {
            setPreviewUrl(null);
            return;
        }
        const objectUrl = URL.createObjectURL(selectedFile);
        setPreviewUrl(objectUrl);
        return () => URL.revokeObjectURL(objectUrl);
    }, [selectedFile]);

    // handleFileChange (sem alterações)
    const handleFileChange = (event) => {
        setError('');
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            if (!file.type.startsWith('image/')) {
                setError('Por favor, selecione um arquivo de imagem.');
                setSelectedFile(null);
                if (fileInputRef.current) fileInputRef.current.value = null;
                return;
            }
            if (file.size > 5 * 1024 * 1024) { // 5MB limit
                setError('O arquivo é muito grande (máximo 5MB).');
                setSelectedFile(null);
                if (fileInputRef.current) fileInputRef.current.value = null;
                return;
            }
            setSelectedFile(file);
        } else {
            setSelectedFile(null);
        }
    };

    // --- NOVO: Handler para inputs de configuração ---
    const handleConfigChange = (e) => {
        const { name, value } = e.target;
        setConfiguracoes(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        if (!currentUser) return;
        setLoading(true);
        setError('');

        try {
            const formData = new FormData();

            // --- ATUALIZADO: Adiciona todos os campos ao FormData ---
            if (selectedFile) {
                formData.append('logomarca', selectedFile);
            }
            // Adiciona os outros campos de configuração
            formData.append('etiqueta_coletiva_largura_mm', configuracoes.etiqueta_coletiva_largura_mm || '');
            formData.append('etiqueta_coletiva_altura_mm', configuracoes.etiqueta_coletiva_altura_mm || '');
            formData.append('etiqueta_individual_largura_mm', configuracoes.etiqueta_individual_largura_mm || '');
            formData.append('etiqueta_individual_altura_mm', configuracoes.etiqueta_individual_altura_mm || '');
            formData.append('etiqueta_romaneio_largura_mm', configuracoes.etiqueta_romaneio_largura_mm || '');
            formData.append('etiqueta_romaneio_altura_mm', configuracoes.etiqueta_romaneio_altura_mm || '');
            formData.append('movimentar_estoque_pedido', configuracoes.movimentar_estoque_pedido);
            formData.append('tipo_pedido_padrao', configuracoes.tipo_pedido_padrao);

            // Chama a API PUT
            const data = await apiCall('/api/configuracoes', 'PUT', formData, true);

            // --- ATUALIZADO: Atualiza o estado com a resposta ---
            setConfiguracoes(data);
            setSelectedFile(null);
            if (fileInputRef.current) fileInputRef.current.value = null;

            Swal.fire('Sucesso!', 'Configurações salvas.', 'success');
            onClose(); // Fecha o modal

        } catch (err) {
            setError('Erro ao salvar: ' + err.message);
            Swal.fire('Erro', 'Não foi possível salvar as configurações.', 'error');
        } finally {
            setLoading(false);
        }
    };

    if (!isVisible) return null;

    // --- ATUALIZADO: URL de display usa o estado `configuracoes` ---
    // (Assumindo que logomarca_url é uma URL completa vinda do seu storage)
    const displayLogoUrl = configuracoes.logomarca_url;

    return (
        <div style={modalStyle}>
            <div style={contentStyle}>
                <div className="modal-header d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
                    <h5 className="modal-title mb-0">Configurações</h5>
                    <button type="button" className="btn-close" onClick={onClose} disabled={loading}></button>
                </div>

                {/* --- NOVO: NAVEGAÇÃO DAS ABAS --- */}
                <ul className="nav nav-tabs mb-3 modal-config-tabs">
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'geral' ? 'active' : ''}`}
                            onClick={() => setActiveTab('geral')}
                        >
                            Geral
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'etiquetas' ? 'active' : ''}`}
                            onClick={() => setActiveTab('etiquetas')}
                        >
                            Etiquetas
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            className={`nav-link ${activeTab === 'pedidos' ? 'active' : ''}`}
                            onClick={() => setActiveTab('pedidos')}
                        >
                            Pedidos
                        </button>
                    </li>
                </ul>

                <div className="modal-body" style={{ minHeight: '250px' }}>
                    {error && <div className="alert alert-danger">{error}</div>}

                    {/* --- NOVO: CONTEÚDO DAS ABAS --- */}
                    <div className="tab-content">
                        {/* Aba Geral */}
                        <div className={`tab-pane fade ${activeTab === 'geral' ? 'show active' : ''}`}>
                            <div className="mb-3">
                                <label htmlFor="logomarcaInput" className="form-label fw-bold">Logomarca</label>
                                <input
                                    ref={fileInputRef}
                                    className="form-control"
                                    type="file"
                                    id="logomarcaInput"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    disabled={loading}
                                />
                                <div className="form-text">Selecione uma imagem (PNG, JPG, etc. Máx 5MB).</div>
                            </div>
                            <div className="text-center mt-3 mb-2 border p-2 bg-light rounded" style={{ minHeight: '100px' }}>
                                <h6 className="text-muted small mb-2">Preview</h6>
                                {previewUrl ? (
                                    <img src={previewUrl} alt="Preview da nova logomarca" style={{ maxWidth: '150px', maxHeight: '80px', display: 'block', margin: 'auto' }} />
                                ) : displayLogoUrl ? (
                                    <img src={displayLogoUrl} alt="Logomarca atual" style={{ maxWidth: '150px', maxHeight: '80px', display: 'block', margin: 'auto' }} />
                                ) : (
                                    <span className="text-muted">Nenhuma logomarca definida.</span>
                                )}
                            </div>
                        </div>

                        {/* Aba Etiquetas */}
                        <div className={`tab-pane fade ${activeTab === 'etiquetas' ? 'show active' : ''}`}>
                            <h6 className="fw-bold">Etiquetas Coletivas</h6>
                            <div className="row">
                                <EtiquetaInput
                                    label="Largura Coletiva"
                                    name="etiqueta_coletiva_largura_mm"
                                    value={configuracoes.etiqueta_coletiva_largura_mm}
                                    onChange={handleConfigChange}
                                    placeholder="Ex: 100"
                                    loading={loading}
                                />
                                <EtiquetaInput
                                    label="Altura Coletiva"
                                    name="etiqueta_coletiva_altura_mm"
                                    value={configuracoes.etiqueta_coletiva_altura_mm}
                                    onChange={handleConfigChange}
                                    placeholder="Ex: 60"
                                    loading={loading}
                                />
                            </div>

                            <hr className="my-3" />

                            <h6 className="fw-bold">Etiquetas Individuais</h6>
                            <div className="row">
                                <EtiquetaInput
                                    label="Largura Individual"
                                    name="etiqueta_individual_largura_mm"
                                    value={configuracoes.etiqueta_individual_largura_mm}
                                    onChange={handleConfigChange}
                                    placeholder="Ex: 70"
                                    loading={loading}
                                />
                                <EtiquetaInput
                                    label="Altura Individual"
                                    name="etiqueta_individual_altura_mm"
                                    value={configuracoes.etiqueta_individual_altura_mm}
                                    onChange={handleConfigChange}
                                    placeholder="Ex: 25"
                                    loading={loading}
                                />
                            </div>
                            <hr className="my-3" />

                            <h6 className="fw-bold">Etiqueta de Romaneio (Pedido)</h6>
                            <div className="row">
                                <EtiquetaInput
                                    label="Largura Romaneio"
                                    name="etiqueta_romaneio_largura_mm"
                                    value={configuracoes.etiqueta_romaneio_largura_mm}
                                    onChange={handleConfigChange}
                                    placeholder="Ex: 100"
                                    loading={loading}
                                />
                                <EtiquetaInput
                                    label="Altura Romaneio"
                                    name="etiqueta_romaneio_altura_mm"
                                    value={configuracoes.etiqueta_romaneio_altura_mm}
                                    onChange={handleConfigChange}
                                    placeholder="Ex: 60"
                                    loading={loading}
                                />
                            </div>
                        </div>
                        {/* Aba Pedidos */}
                        <div className={`tab-pane fade ${activeTab === 'pedidos' ? 'show active' : ''}`}>
                            <h6 className="fw-bold">Configurações de Pedidos</h6>
                            <div className="form-check form-switch mt-3">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="movimentarEstoqueCheck"
                                    name="movimentar_estoque_pedido"
                                    checked={configuracoes.movimentar_estoque_pedido}
                                    onChange={(e) => setConfiguracoes(prev => ({ ...prev, [e.target.name]: e.target.checked }))}
                                    disabled={!hasModuloEstoque}
                                />
                                <label className="form-check-label" htmlFor="movimentarEstoqueCheck">
                                    Movimentar estoque ao salvar pedido (automático)
                                </label>
                                <InfoTooltip>
                                    {!hasModuloEstoque ? <span className="text-danger fw-bold">Módulo de Estoque não disponível no seu plano.</span> : 'Necessário ter o módulo de Estoque ativo para que essa função tenha efeito.'}
                                </InfoTooltip>
                            </div>

                            <div className="mt-4">
                                <label htmlFor="tipoPedidoSelect" className="form-label fw-bold">
                                    Tipo padrão no pedido
                                    <InfoTooltip>
                                        Define qual tipo virá selecionado ao criar um novo pedido.
                                        {!hasModuloEstoque && <br />}
                                        {!hasModuloEstoque && <span className="text-danger fw-bold">Opção 'Estoque' indisponível no seu plano.</span>}
                                        <hr className="my-1" />
                                        <strong>Representação:</strong> Não movimenta estoque, oculta checkbox.
                                        <br />
                                        <strong>Estoque:</strong> Habilita controle de estoque e oculta aba "Financeiro a Pagar".
                                    </InfoTooltip>
                                </label>
                                <select
                                    className="form-select"
                                    id="tipoPedidoSelect"
                                    name="tipo_pedido_padrao"
                                    value={configuracoes.tipo_pedido_padrao}
                                    onChange={handleConfigChange}
                                    disabled={!hasModuloEstoque}
                                >
                                    <option value="Representacao">Representação (Padrão)</option>
                                    <option value="Estoque">Estoque</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-footer pt-3 border-top modal-config-footer">
                    <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary-config"
                        onClick={handleSave}
                        disabled={loading} // Simplificado - permite salvar mesmo sem mudanças
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Salvando...
                            </>
                        ) : 'Salvar Configurações'}
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ModalConfiguracoes;